//============================================================================
// Name        : types.ts
// Purpose     : Define manufacturing module types
// Created     : 2019-08-26
// Author      : Daniel Ansari
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

//============================================================================
// Type Aliases
//============================================================================
export type ChangeInputEvent    = React.ChangeEvent<HTMLInputElement>;

//============================================================================
// Redux Store Actions
//============================================================================
export enum TagRequestActions {
    UpdateState = "UpdateState",
    StoreTagRequestProps = "StoreTagRequestProps",
    Continue = "Continue",
    SetSelectedReason = "SetSelectedReason",
    SetReasonState = "SetReasonState",
    SetSelectedUom = "SetSelectedUom",
    SetUomState = "SetUomState",
}
//============================================================================
// Request Component
//============================================================================

export interface ITaggingRequestProps {
    searchUrl: string;
    requestUrl: string;
}

export interface ITaggingRequestState {
    query: string;
    taggingRequestItems: IItem[];
}

//============================================================================
// Request Component
//============================================================================

export interface IItem {
    id: number;
    alu: string;
    number: string;
    description: string;
}


export interface ITagRequestProps {
    tagRequest: Partial<IItem>;
    currentItemId: number;

    // Virtual Properties
    number: string;
    description: string;
    item_id: string;
    qty: string;
    lot: string;
    expirated_at: string;
    transaction_id: string;
    reason: string;
    uom: string;
    storages: Array<IUomOption>;
    selectedReason: IReasonOption;
    selectedUom: IUomOption;

    // Actions
    storeTagRequestProps: (props: ITagRequestProps) => void;
    setSelectedReason?: (option: IReasonOption) => void;
    setSelectedUom?: (option: IUomOption) => void;
    updateState: (newState: object) => void;
}

//============================================================================
// Redux Store
//============================================================================

export interface IReasonOption {
    value: string;
    label: string;
}

export interface IReasonState {
    selectedReason: IReasonOption;
    setSelectedReason?: (option: IReasonOption) => void;
}

export interface IUomOption {
    value: string;
    label: string;
}

export interface IUomState {
    selectedUom: IUomOption;
    setSelectedUom?: (option: IUomOption) => void;
}
